module.exports = __webpack_public_path__ + "img/profile.fdcda7b4.svg";